import axios from 'axios';

const ENDPOINT_BASE_URL = `/api/notifications`;

class NotificationService {
    async table(data) {
        const res = await axios.post(`${ENDPOINT_BASE_URL}/table`, data);
        return res.data;
    }
    async save(data) {
        const res = await axios.post(`${ENDPOINT_BASE_URL}/save`, data);
        return res.data;
    }

    async editUsers(data) {
        const res = await axios.post(`${ENDPOINT_BASE_URL}/edit-users`, data);
        return res.data;
    }
    async search(q) {
        const res = await axios.get(ENDPOINT_BASE_URL + '?q=' + q);
        return res.data;
    }
    async delete(itemId) {
        const res = await axios.get(ENDPOINT_BASE_URL + '/delete/' + itemId);
        return res.data;
    }
}

export default new NotificationService();